import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  opacity: ${({ active }) => (active ? 1 : 0.5)};
  border: 4px solid;
  border-color: ${({ active }) => (active ? '#aef72f' : 'white')};
  width: calc(50% - 20px);
  margin: 10px;
  padding: 30px 20px 15px 15px;
  display: flex;
  flex-direction: column;
  min-height: 300px;

  @media (max-width: 550px) {
    width: auto;
  }
`;

const Emojis = styled.div`
  margin-bottom: 0.5em;
`;

const Title = styled.div`
  margin-bottom: 1em;
`;

const Description = styled.div`
  font-size: 0.7em;
  flex-grow: 1;
  margin-bottom: 2em;
`;

const UnlocksAt = styled.div`
  font-size: 0.7em;
`;

export default function Perk({ title, description, active, unlocksAt, emoji }) {
  return (
    <Wrap active={active}>
      <Emojis>{emoji}</Emojis>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <UnlocksAt>
        {active ? <span>Unlocked</span> : <span>Unlocks</span>}
        {unlocksAt > 0 && <span> at {unlocksAt} ETH</span>}
      </UnlocksAt>
    </Wrap>
  );
}
